
import { iModals_state } from "../../common/interfaces/interfaces"
import { modalsActionTypes, modals_actions_type } from "./modalsTypes"

const initial_state: iModals_state = {
   buttonBlock: false,
   infoModal: false,
   infoModalMsg: '',
   withdrawModal: false,
   depositModal: false,
   transactionModal: false,
   historyModal: false,
   changeDepositModal: false,
   changeRequestType: null,
   warningRequestModal: false,
   priceHistoryModal: false
}

export const modalsReducer = (state = initial_state, action: modals_actions_type) : iModals_state => {
    switch(action.type) {
        case modalsActionTypes.SET_BUTTON_BLOCK:
            return {...state, buttonBlock: action.payload}

        case modalsActionTypes.SET_INFO_MODAL:
            return {...state, infoModal: action.payload}

        case modalsActionTypes.SET_INFO_MODAL_MSG:
            return {...state, infoModalMsg: action.payload}

        case modalsActionTypes.SET_WITHDRAW_MODAL:
            return {...state, withdrawModal: action.payload}

        case modalsActionTypes.SET_DEPOSIT_MODAL:
            return {...state, depositModal: action.payload}

        case modalsActionTypes.SET_TRANSACTION_MODAL:
            return {...state, transactionModal: action.payload}

        case modalsActionTypes.SET_HISTORY_MODAL:
            return {...state, historyModal: action.payload}

        case modalsActionTypes.SET_PRICE_HISTORY_MODAL:
            return {...state, priceHistoryModal: action.payload}

        case modalsActionTypes.SET_CHANGE_DEPOSIT_MODAL:
            return {...state, changeDepositModal: action.payload}
        
        case modalsActionTypes.SET_REQUEST_TYPE:
            return {...state, changeRequestType: action.payload}

        case modalsActionTypes.SET_WARNING_REQUEST_MODAL:
            return {...state, warningRequestModal: action.payload}
    
        default: return state;
    }
}